<template>
	<div
		v-if="isOpen"
		:class="{'modal--open':isOpen}"
		class="modal">
		<div
			@click.self="closeModal"
			class="modal__background">
		</div>
		<div class="modal__content">
			<component v-if="contentComponent" :is="contentComponent">
			</component>
		</div>
	</div>
</template>

<script>
import Discussion from '@/components/Discussion'
import Popup from '@/components/Popup'
export default {
	components: {
		Discussion,
		Popup
	},
	data () {
		return {
		}
	},
	methods: {
		closeModal () {
			this.$store.dispatch('closeModal')
		}
	},
	computed: {
		isOpen () {
			return this.$store.state.modal.open
		},
		contentComponent () {
			const content = this.$store.state.modal.content
			if (!content.component) return null
			var contentComponent = null
			switch (content.component) {
			case 'Discussion':
				contentComponent = Discussion
				break
			case 'Popup':
				contentComponent = Popup
			}
			return contentComponent
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_modal.scss";
</style>
